import { TestCaseSearchResult } from "../../../api/models/test-series/TestCaseSearchResult";

type ValidatableTestCase = TestCaseSearchResult & { invalid: boolean };

export function initValidatableTestCases(testCases: TestCaseSearchResult[]) {
  return testCases.map((tc) => ({
    ...tc,
    invalid: false,
  }));
}

export function validateTestCases(
  validateable: ValidatableTestCase[],
  validator: (testCase: ValidatableTestCase) => boolean,
) {
  return validateable.map((vtc) => ({
    ...vtc,
    invalid: validator(vtc),
  }));
}

export default ValidatableTestCase;
